import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import TableList from '@/components/TableList/index.vue';
import { getPlaysmart } from '@/api/dashboard/overview';

export default {
  components: {
    TableList: TableList
  },
  data: function data() {
    return {
      columnConfig: [{
        label: '日期',
        prop: 'date'
      }, {
        label: '动态endcard',
        prop: 'endcard'
      }, {
        label: 'playable 2d',
        prop: 'playable2d'
      }, {
        label: 'playable 3d',
        prop: 'playable3d'
      }, {
        label: '交互视频',
        prop: 'video'
      }],
      dataSource: []
    };
  },
  mounted: function mounted() {
    this.initData();
  },

  methods: {
    initData: function initData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getPlaysmart();

              case 3:
                res = _context.sent;

                _this.dataSource = _.get(res, 'data.data.items');
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  },
  computed: {
    list: function list() {
      var dataSource = this.dataSource;

      if (!dataSource) return [];
      return dataSource.map(function (data) {
        return {
          date: data.start + ' ~ ' + data.end,
          playable2d: data.playable_2d,
          playable3d: data.playable_3d,
          endcard: data.interactive_endcard,
          video: data.interactive_video
        };
      });
    }
  }
};